export const WIKICV_SELECTORS = {
  metadata: {
    title: ".book-info .cover-info h2",
    author: ".book-info .cover-info a[href*='/tac-gia/']",
    description: ".book-desc-detail",
    cover: ".book-info .cover-wrapper img",
    genresContainer: ".book-desc",
    // FRAGILE positional selector (unverified): if wikicv reorders the cover-info
    // divs, status silently becomes "unknown". Candidate fallback to validate next
    // survey: a[href*='/trang-thai/']. See docs/surveys/2026-06-20-review-deferred-verification.md
    statusAnchor: ".book-info .cover-info div:nth-of-type(4) a",
    // "Mới nhất:" line in the static novel HTML — anchor href points to the
    // most-recent chapter, e.g. /chuong-265-... — and the anchor text reads
    // "Chương 265 ...". For wikicv the chapter index is monotonically
    // increasing from 1, so the latest index equals the source TOC size.
    latestChapterAnchor: ".book-info a[href*='/chuong-']",
  },
  toc: {
    chapterList: "li.chapter-name a",
  },
  chapter: {
    bodyRoot: "#bookContentBody",
    titleBlock: "p.book-title",
  },
} as const;
